/* Wall art product page: one selection for the whole page. Spec: docs/superpowers/specs/2026-10-08-wall-art-front-page-pdp-design.md.
 * Tested by _review/test-wall-art.js on _review/wall-art-fixture.html. Contract: sections/wall-art.liquid.
 * No <form>: DealEasy rewrites product-form quantities store-wide, so Add to cart posts to /cart/add.js. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wa-pdp]');
  var M = window.WallArtModel;
  if (!root || !M) return;

  // Typographer's quotes (Task 17) in the description (About the art's body) and the FAQ answers, once, on load: every
  // text node, through WallArtModel.curlText, the quote state carried from node to node within a block (p, li, ...) so a
  // quote that opens in one node and closes in another still pairs. Text inside links converts (attributes are not text
  // nodes); code, pre, input, textarea, script and style are skipped. The section curls its plain-text fields
  // server-side. data-wa-curled marks a container done, so a second run changes nothing (the output is idempotent too).
  function curlQuotes(container) {
    if (!M.curlText || !container || container.hasAttribute('data-wa-curled')) return;
    container.setAttribute('data-wa-curled', '');
    var SKIP = 'code, pre, input, textarea, script, style', BLOCK = 'p, li, dd, dt, td, th, blockquote, h1, h2, h3, h4, h5, h6, figcaption, summary, div';
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.parentElement && n.parentElement.closest(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    var state = M.quoteState(), block = null, node;
    while ((node = walker.nextNode())) {
      var b = node.parentElement.closest(BLOCK) || container;
      if (b !== block) { block = b; state = M.quoteState(); }
      var t = node.nodeValue;
      if (!/["']/.test(t)) { if (t) state.prev = t.charAt(t.length - 1); continue; }
      var curled = M.curlText(t, state);
      if (curled !== t) node.nodeValue = curled;
    }
  }
  curlQuotes(root.querySelector('.wa-about__body'));
  Array.prototype.forEach.call(root.querySelectorAll('.wa-faq__item > :not(summary)'), curlQuotes);

  // The full-bleed bands are sized from the viewport; a classic scrollbar makes 100vw wider than the page.
  function scrollbar() { root.style.setProperty('--wa-sb', (window.innerWidth - document.documentElement.clientWidth) + 'px'); }
  scrollbar();
  window.addEventListener('resize', scrollbar);

  // Sticky gallery (Task 19). In the two-column hero the CSS pins .wa-gallery.is-sticky while the buy column scrolls; the
  // class is on only when the gallery plus its top gap fits in the viewport, otherwise the gallery stays static so its
  // thumbnails are never out of reach. Re-checked on load, resize, and whenever the gallery changes size (the GG slider
  // builds late). Sticky changes no box size, so the observer cannot feed itself. If the theme header is ever fixed or
  // sticky at the top, its height is added to the gap.
  (function () {
    var gallery = root.querySelector('.wa-gallery');
    if (!gallery) return;
    var GAP = 24;
    function pinnedHeader() {
      var found = document.querySelectorAll('.site-header, #shopify-section-header, header'), h = null;
      for (var i = 0; i < found.length && !h; i++) if (!root.contains(found[i])) h = found[i];   // the theme's, not one of ours
      if (!h) return 0;
      var pos = getComputedStyle(h).position, r = h.getBoundingClientRect();
      return (pos === 'fixed' || pos === 'sticky') && r.height > 0 ? Math.ceil(Math.max(0, r.bottom)) : 0;
    }
    function check() {
      var top = GAP + pinnedHeader();
      root.style.setProperty('--wa-sticky-top', top + 'px');
      var twoCols = window.matchMedia ? window.matchMedia('(min-width: 900px)').matches : window.innerWidth >= 900;   // the CSS's own breakpoint
      gallery.classList.toggle('is-sticky', twoCols && gallery.offsetHeight > 0 && gallery.offsetHeight + top <= window.innerHeight);
    }
    check();
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(gallery);
  })();

  // The gallery's 3D slide (Tasks 20, 23): a live preview that turns by dragging. The GG slider (pmslider) builds the
  // gallery's inline <model-viewer> (in .pmslider-model-viewer) with auto-rotate and a cube button over it; a click on
  // either opens pmslider's full-screen viewer (the one with zoom and AR). Here the inline viewer also gets
  // camera-controls, so a drag turns the model in place: touch-action pan-y (a vertical drag still scrolls the page),
  // disable-zoom (the wheel and pinch stay the page's; zoom lives in full screen and the 3D section), no interaction
  // prompt. It keeps spinning while idle: model-viewer pauses auto-rotate while the shopper turns it and resumes from
  // there after auto-rotate-delay (3 s); no auto-rotate under prefers-reduced-motion. `ar` lets pd-3d-variants.js keep
  // it on the chosen size's GLB as well as the chosen finish, as it does the 3D section's viewer (its AR button and
  // label are hidden by the CSS). A click or tap on the model never opens full screen (stopped in capture on the
  // gallery, before pmslider's listener on the viewer); the cube is hidden, and a "View full screen" button at the
  // slide's top right does what the cube did. pmslider creates the viewer late and can recreate it, so a
  // MutationObserver on .wa-gallery re-applies all this, idempotently. Its touch swipe (a touchmove of 30px across on
  // its slides wrapper) never gets a touchmove from inside the viewer. Each viewer set up here is handed to
  // galleryViewer() (below: the camera aim and the starting size, once the selection model is up).
  // The first time the 3D slide shows (Task 24), the model turns left and right once to show it moves; see intro below.
  var galleryViewer = function () {}, galleryTurnStop = function () {}, gallerySrc = function () {};
  (function () {
    var gallery = root.querySelector('.wa-gallery');
    if (!gallery) return;
    var ATTRS = { 'camera-controls': '', 'touch-action': 'pan-y', 'disable-zoom': '', 'interaction-prompt': 'none', 'ar': '' };
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var ICON = '<svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M216,48V96a8,8,0,0,1-16,0V67.31l-42.34,42.35a8,8,0,0,1-11.32-11.32L188.69,56H160a8,8,0,0,1,0-16h48A8,8,0,0,1,216,48ZM98.34,146.34,56,188.69V160a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8H96a8,8,0,0,0,0-16H67.31l42.35-42.34a8,8,0,0,0-11.32-11.32ZM208,152a8,8,0,0,0-8,8v28.69l-42.34-42.35a8,8,0,0,0-11.32,11.32L188.69,200H160a8,8,0,0,0,0,16h48a8,8,0,0,0,8-8V160A8,8,0,0,0,208,152ZM67.31,56H96a8,8,0,0,0,0-16H48a8,8,0,0,0-8,8V96a8,8,0,0,0,16,0V67.31l42.34,42.35a8,8,0,0,0,11.32-11.32Z"/></svg>';
    var down = null, opening = false;
    // pmslider's full-screen viewer sits in its modal (.pmslider-modal > .pmslider-modal--dialog > .pmslider-modal--content,
    // appended to <body>); it is excluded by name too, so a modal ever mounted inside the gallery stays pmslider's own.
    var MODAL = '.pmslider-modal, .pmslider-modal--dialog, .pmslider-modal--content';
    function inline(el) {
      return el && el.tagName === 'MODEL-VIEWER' && !el.hasAttribute('data-wa-model') && el.parentElement &&
        el.parentElement.classList.contains('pmslider-model-viewer') && gallery.contains(el) && !el.closest(MODAL) ? el : null;
    }
    // Full screen, as pmslider's cube did: its own button's click (hidden, still listened to), else the viewer's click,
    // let through the capture guard below. Focus comes back to the button when the viewer closes: <body>'s class is
    // watched from the click on, so a viewer that opens late is followed too; if pmslider-modal-open has not appeared
    // within 2 s, the watch ends.
    var OPEN = 'pmslider-modal-open', watching = null;
    function openFull(box, btn) {
      var cube = box.querySelector(':scope > .pmslider-button'), mv = box.querySelector(':scope > model-viewer');
      if (watching) watching();
      if ('MutationObserver' in window) {
        var seen = false, timer = null;
        var has = function (cls) { return (' ' + (cls || '') + ' ').indexOf(' ' + OPEN + ' ') !== -1; };
        var stop = function () { watch.disconnect(); clearTimeout(timer); if (watching === stop) watching = null; };
        var watch = new MutationObserver(function (records) {
          records.forEach(function (r) { if (has(r.oldValue)) seen = true; });
          if (document.body.classList.contains(OPEN)) { seen = true; clearTimeout(timer); return; }
          if (!seen) return;
          stop();
          if (btn.isConnected) { try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); } }
        });
        watch.observe(document.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
        timer = setTimeout(function () { if (!seen) stop(); }, 2000);
        watching = stop;
      }
      if (cube) cube.click();
      else if (mv) { opening = true; try { mv.click(); } finally { opening = false; } }
    }
    // The button sits inside the 3D slide, so it shows only there; it leaves the tab order while another slide is current
    // (focus on a slide out of view would scroll the slider's clipped track).
    function current(box) {
      var slide = box.closest('.pmslider-slide');
      return !slide || slide.getAttribute('data-pmslider-slide-active') === 'true';
    }
    function button(box) {
      var btn = box.querySelector(':scope > .wa-3d-full');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wa-3d-full';
        btn.setAttribute('aria-label', 'View full screen');
        btn.innerHTML = ICON;
        btn.addEventListener('click', function (e) { e.stopPropagation(); openFull(box, btn); });
        box.appendChild(btn);
      }
      // pmslider's slides are wider and taller than the clipped wrapper that shows them (its gap between slides), so
      // the corner offset counts from what shows.
      var wrap = box.closest('.pmslider-own--slides-wrapper'), b = box.getBoundingClientRect(), w = wrap && wrap.getBoundingClientRect();
      if (w && w.width && b.width) {
        var ix = Math.max(0, Math.round((b.width - w.width) / 2)) + 'px', iy = Math.max(0, Math.round((b.height - w.height) / 2)) + 'px';
        if (btn.style.getPropertyValue('--wa-3d-ix') !== ix) btn.style.setProperty('--wa-3d-ix', ix);
        if (btn.style.getPropertyValue('--wa-3d-iy') !== iy) btn.style.setProperty('--wa-3d-iy', iy);
      }
      var on = current(box);
      if (btn.tabIndex !== (on ? 0 : -1)) btn.tabIndex = on ? 0 : -1;
      if (on) { if (btn.hasAttribute('aria-hidden')) btn.removeAttribute('aria-hidden'); }
      else if (btn.getAttribute('aria-hidden') !== 'true') btn.setAttribute('aria-hidden', 'true');
    }
    // The intro turn (Task 24): once per page view, the first time the 3D slide is the current slide, its model has
    // loaded on the selected size (data-wa-sized, set by galleryViewer below) and at least half of it is in the viewport,
    // the camera turns about 30 degrees one way, 30 past centre the other way and back to the front (1.4 s, each leg
    // eased in and out, theta only: phi and distance are read back every frame, so pd-3d-camera's framing and the aim
    // hold). It is driven here, frame by frame (cameraOrbit, then jumpCameraToGoal); model-viewer's interaction prompt
    // shows a hand, so it stays off. Auto-rotate is held off until then; after the turn it starts 300 ms later
    // (auto-rotate-delay 300, put back to 3000 once it is turning, or at the shopper's first touch), so from then on it
    // behaves as above. The shopper always wins: a pointerdown, touchstart, wheel or keydown in the slide, or a change of
    // selection, stops the turn where it is (no snap); a slide change stops it and puts the camera back at the front; a
    // new camera target or a size refit (aim, below) stops it first. A stopped turn counts as done. Skipped under
    // prefers-reduced-motion. Never the full-screen viewer or the 3D section's (inline() excludes them).
    // Never behind pmslider's full-screen viewer either: while it is open the turn does not start (the "View full
    // screen" button's own pointerdown or Enter is not the shopper taking over), and a turn under way when it opens goes
    // back to the front and is still to come, so it plays inline once the viewer closes.
    // A release (so the spin is never held for good): if the turn has not started 8 s after the slide became current,
    // it is tried once more on where the slide is then (in case no IntersectionObserver callback came), and otherwise
    // auto-rotate starts and the intro counts as done. That clock stops while another slide is current or the full-screen
    // viewer is open. pd-3d-camera's starting framing is waited for at most 3 s (30 checks, 100 ms apart).
    // Per-viewer state (in view, a check queued, those retries, the release clock) is kept by viewer element, so a viewer
    // pmslider recreates starts fresh; what is once per page view (the intro's state) is not.
    var LEGS = [350, 700, 350], SWING = 30 * Math.PI / 180, BEAT = '300', DELAY = '3000', RELEASE = 8000, RETRIES = 30;
    var intro = { state: 'waiting', mv: null, raf: 0, timer: 0, base: 0, sel: null, lastSel: null };
    var views = new WeakMap();
    function view(mv) {
      var v = views.get(mv);
      if (!v) views.set(mv, v = { inView: false, queued: false, retries: 0, release: 0, retried: false });
      return v;
    }
    // At least half of the viewer is in view, by height: half its height, or half the window's when the viewer is
    // taller than the window (its share of the area could then never reach one half).
    function halfIn(height, shown, windowHeight) { return height > 0 && shown >= 0.49 * Math.min(height, windowHeight); }
    var STEPS = []; for (var q = 0; q <= 20; q++) STEPS.push(q / 20);
    var io = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        view(e.target).inView = e.isIntersecting && e.intersectionRect.width > 0 &&
          halfIn(e.boundingClientRect.height, e.intersectionRect.height, e.rootBounds ? e.rootBounds.height : window.innerHeight);
        if (inline(e.target)) introCheck(e.target);
      });
    }, { threshold: STEPS }) : null;
    function inViewNow(mv) {
      var r = mv.getBoundingClientRect(), wh = window.innerHeight;
      return r.right > 0 && r.left < window.innerWidth && halfIn(r.height, Math.min(wh, r.bottom) - Math.max(0, r.top), wh);
    }
    function modalOpen() { return document.body.classList.contains(OPEN) || !!document.querySelector('.pmslider-modal.is-open'); }
    var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) { return setTimeout(function () { f(Date.now()); }, 16); };
    var unraf = window.cancelAnimationFrame ? window.cancelAnimationFrame.bind(window) : clearTimeout;
    function holding() { return intro.state === 'waiting' || intro.state === 'turning'; }
    // Offset from the front at ms into the turn: + first (the camera to the model's right, so the art turns to the
    // viewer's left), then - (past centre), then 0.
    function swingAt(ms) {
      var ease = function (x) { return (1 - Math.cos(Math.PI * Math.min(1, Math.max(0, x)))) / 2; };
      if (ms < LEGS[0]) return SWING * ease(ms / LEGS[0]);
      if (ms < LEGS[0] + LEGS[1]) return SWING * (1 - 2 * ease((ms - LEGS[0]) / LEGS[1]));
      return -SWING * (1 - ease((ms - LEGS[0] - LEGS[1]) / LEGS[2]));
    }
    function orbitTo(mv, theta) {
      var o = mv.getCameraOrbit();
      mv.cameraOrbit = theta + 'rad ' + o.phi + 'rad ' + o.radius + 'm';
      mv.jumpCameraToGoal();
    }
    function introEnd(state) {
      var mv = intro.mv;
      if (intro.raf) unraf(intro.raf);
      clearTimeout(intro.timer);
      intro.raf = 0;
      intro.state = state;
      if (state === 'beat') intro.timer = setTimeout(function () { if (intro.state === 'beat') introEnd('done'); }, 3200);
      Array.prototype.forEach.call(gallery.querySelectorAll('model-viewer[data-wa-drag]'), function (g) { if (inline(g)) enable(g); });
      if (mv && mv.isConnected && inline(mv)) enable(mv);
    }
    // toFront: a slide change (or reduced motion turned on) leaves the camera at the front for the slide's return.
    // Otherwise the camera stays where the turn was, and the viewer counts as turned (pd-3d-camera's data-pd-touched),
    // as if the shopper had turned it: else pd-3d-camera would put it back to the front on the next load (a size
    // change's new model), a snap.
    function introStop(toFront) {
      if (intro.state === 'done') return;
      var mv = intro.mv;
      if (intro.state === 'turning' && mv && mv.isConnected) {
        try {
          if (toFront) orbitTo(mv, intro.base);
          else if (Math.abs(mv.getCameraOrbit().theta - intro.base) > 1e-4) mv.dataset.pdTouched = '1';
        } catch (e) { /* not model-viewer */ }
      }
      introEnd('done');
    }
    galleryTurnStop = function (mv) { if (intro.state === 'turning' && intro.mv === mv) introStop(false); };
    // The full-screen viewer opened mid-turn: back to the front, and the turn is still to come.
    function introRewind() {
      if (intro.state !== 'turning') return;
      var mv = intro.mv;
      if (intro.raf) unraf(intro.raf);
      intro.raf = 0;
      try { if (mv && mv.isConnected) orbitTo(mv, intro.base); } catch (e) { /* not model-viewer */ }
      intro.state = 'waiting';
      intro.mv = null;
    }
    // The turn's clock moves on by the time between frames, but at most FRAME per frame: a stalled frame (a first render
    // right after the model's first load can take a second on a slow device) pauses the turn rather than skipping it.
    var FRAME = 50;
    function step(mv, last, ms) {
      return function (now) {
        if (intro.state !== 'turning' || intro.mv !== mv) return;
        if (!mv.isConnected || !current(mv.parentElement) || (motion && motion.matches)) { introStop(true); return; }
        if (modalOpen()) { introRewind(); return; }
        ms += last === null ? 0 : Math.min(FRAME, Math.max(0, now - last));
        var done = ms >= LEGS[0] + LEGS[1] + LEGS[2];
        try { orbitTo(mv, intro.base + (done ? 0 : swingAt(ms))); } catch (e) { introEnd('done'); return; }
        if (done) introEnd('beat');
        else intro.raf = raf(step(mv, now, ms));
      };
    }
    function ready(mv) {
      return current(mv.parentElement) && mv.hasAttribute('data-wa-sized') && !modalOpen() && (!io || view(mv).inView);
    }
    // The release clock: running while this viewer's slide is current and the full-screen viewer is closed.
    function release(mv) {
      var v = view(mv);
      if (intro.state !== 'waiting' || !current(mv.parentElement) || modalOpen()) {
        if (v.release) { clearTimeout(v.release); v.release = 0; }
        return;
      }
      if (v.release) return;
      v.release = setTimeout(function fire() {
        v.release = 0;
        if (intro.state !== 'waiting' || !mv.isConnected || !inline(mv) || !current(mv.parentElement) || modalOpen()) return;
        if (!v.retried && (!io || inViewNow(mv))) {    // once more, on where the slide is now; then give up 1 s later
          v.retried = true;
          if (io) v.inView = true;
          introCheck(mv);
          v.release = setTimeout(fire, 1000);
          return;
        }
        introEnd('done');
      }, +gallery.getAttribute('data-wa-intro-wait') || RELEASE);   // (a shorter wait for the review fixture only)
    }
    function introCheck(mv) {
      if (intro.state !== 'waiting') return;
      if (motion && motion.matches) { introEnd('done'); return; }
      var v = view(mv);
      release(mv);
      if (!ready(mv) || v.queued) return;
      v.queued = true;
      raf(function () {     // a frame after the load, so pd-3d-camera has framed it
        v.queued = false;
        if (intro.state !== 'waiting' || !mv.isConnected || !inline(mv) || !ready(mv)) return;
        if (mv.hasAttribute('data-pd-camera') && /auto/.test(mv.getAttribute('camera-orbit') || 'auto') && v.retries < RETRIES) {
          v.retries++;
          setTimeout(function () { introCheck(mv); }, 100);
          return;
        }
        if (!mv.getCameraOrbit || !mv.jumpCameraToGoal) { introEnd('done'); return; }
        if (v.release) { clearTimeout(v.release); v.release = 0; }
        intro.mv = mv;
        intro.base = mv.getCameraOrbit().theta;
        intro.sel = intro.lastSel;
        intro.state = 'turning';
        intro.raf = raf(step(mv, null, 0));
      });
    }
    // The shopper's first touch: before the model has loaded it is not counted (the turn is still to come), nor is the
    // full-screen button's (the turn waits for the viewer to close).
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
      gallery.addEventListener(type, function (e) {
        if (intro.state === 'done') return;
        if (!e.target || !e.target.closest || e.target.closest('.wa-3d-full')) return;
        var box = e.target.closest('[data-wa-drag-box]');
        var mv = box && box.querySelector(':scope > model-viewer');
        if (!mv || !inline(mv)) return;
        if (intro.state === 'waiting' && !mv.hasAttribute('data-wa-loaded')) return;
        introStop(false);
      }, { capture: true, passive: true });
    });
    root.addEventListener('wa:change', function (e) {
      var s = e.detail && e.detail.sel, key = s ? [s.size, s.group, s.finish].join('|') : null;
      intro.lastSel = key;
      if ((intro.state === 'turning' || intro.state === 'beat') && key !== intro.sel) introStop(false);
    });
    function enable(mv) {
      for (var k in ATTRS) if (mv.getAttribute(k) !== ATTRS[k]) mv.setAttribute(k, ATTRS[k]);
      var delay = intro.state === 'beat' ? BEAT : DELAY;
      if (mv.getAttribute('auto-rotate-delay') !== delay) mv.setAttribute('auto-rotate-delay', delay);
      var still = (motion && motion.matches) || holding();
      if (still && mv.hasAttribute('auto-rotate')) mv.removeAttribute('auto-rotate');
      if (!still && !mv.hasAttribute('auto-rotate')) mv.setAttribute('auto-rotate', '');
      var box = mv.parentElement;
      if (!box.hasAttribute('data-wa-drag-box')) box.setAttribute('data-wa-drag-box', '');
      button(box);
      if (mv.hasAttribute('data-wa-drag')) return;
      mv.setAttribute('data-wa-drag', '');
      mv.addEventListener('touchmove', function (e) { e.stopPropagation(); }, { passive: true });
      if (io) io.observe(mv);
      galleryViewer(mv);
    }
    function scan() {
      Array.prototype.forEach.call(gallery.querySelectorAll('.pmslider-model-viewer > model-viewer'), function (mv) {
        if (!inline(mv)) return;
        enable(mv);
        if (intro.state === 'turning' && intro.mv === mv && !current(mv.parentElement)) introStop(true);
        else introCheck(mv);
      });
    }
    function end() {
      if (down) down.removeAttribute('data-wa-grabbing');
      down = null;
    }
    gallery.addEventListener('pointerdown', function (e) {
      var mv = inline(e.target);
      end();
      if (!mv || e.pointerType !== 'mouse' || e.button !== 0) return;
      down = mv;
      mv.setAttribute('data-wa-grabbing', '');
    }, true);
    window.addEventListener('pointerup', end, true);
    window.addEventListener('pointercancel', end, true);
    gallery.addEventListener('click', function (e) {
      if (opening || !inline(e.target)) return;
      e.stopPropagation();
      e.preventDefault();
    }, true);
    // One scan per animation frame however many mutations pmslider makes (the button's corner offset reads layout).
    var queued = false;
    function later() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(function () { queued = false; scan(); });
    }
    scan();
    if ('MutationObserver' in window) {
      // A viewer's src is handled at once, not on the next frame: pmslider's reset to its own model is put back before
      // model-viewer acts on it (gallerySrc, below).
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          if (records[i].attributeName === 'src' && t.hasAttribute('data-wa-drag') && inline(t)) gallerySrc(t);
        }
        later();
      }).observe(gallery, { childList: true, subtree: true, attributes: true,
        attributeFilter: Object.keys(ATTRS).concat(['auto-rotate', 'auto-rotate-delay', 'data-pmslider-slide-active', 'data-wa-sized', 'src']) });
      // pmslider's full-screen viewer opening (a turn under way goes back to the front) and closing (the turn can run).
      new MutationObserver(function () { if (modalOpen()) introRewind(); later(); })
        .observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', later);
    if (motion) {
      if (motion.addEventListener) motion.addEventListener('change', later);
      else if (motion.addListener) motion.addListener(later);
    }
  })();

  function json(sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } }
  var product = json('[data-wa-product]'), cfg = json('[data-wa-config]') || {};
  var styles = json('[data-wa-styles-data]') || [];   // style siblings, one per [data-wa-style] tile (by index)
  var model = product && M.build(product);
  if (!model) return;
  root.classList.add('wa-js');

  var urlId = new URLSearchParams(location.search).get('variant');
  var sel = M.defaultSelection(model, urlId || cfg.variantId);
  var adding = false;           // an Add to cart request is in flight (or the page is leaving for /cart); one lock for every button
  var rendered = false;         // the first render has written the URL
  var lastFinish = sel.finish || (model.finishes[0] && model.finishes[0].value) || null;
  var api = window.wallArtPdp = window.wallArtPdp || {};
  if (!api.go) api.go = function (url) { window.location.href = url; };

  function all(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function setText(s, text) { all(s).forEach(function (el) { if (el.textContent !== text) el.textContent = text; }); }
  function press(el, on) { el.setAttribute('aria-pressed', on ? 'true' : 'false'); }
  function avail(el, ok) { el.setAttribute('aria-disabled', ok ? 'false' : 'true'); el.classList.toggle('is-unavailable', !ok); }
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  // The price fades in when it changes (150 ms, wall-art-pdp.css .wa-swap). The text itself changes at once.
  function swapText(s, text) {
    all(s).forEach(function (el) {
      if (el.textContent === text) return;
      var fade = el.classList.contains('wa-swap') && !reducedMotion();
      if (fade) el.classList.add('is-swapping');
      el.textContent = text;
      if (fade) { void el.offsetWidth; requestAnimationFrame(function () { el.classList.remove('is-swapping'); }); }
    });
  }

  function render() {
    var variant = M.variantFor(model, sel), ok = !!(variant && variant.available);
    all('[data-wa-size]').forEach(function (b) {
      press(b, b.getAttribute('data-wa-size') === sel.size);
    });
    all('[data-wa-from-size]').forEach(function (el) {
      var c = M.sizeFrom(model, el.getAttribute('data-wa-from-size'));
      var t = c == null ? '' : M.money(c);
      if (el.textContent !== t) el.textContent = t;
    });
    all('[data-wa-group]').forEach(function (b) {
      var key = b.getAttribute('data-wa-group');
      press(b, key === sel.group);
      avail(b, key === 'framed'
        ? model.finishes.some(function (f) { return M.isAvailable(model, { size: sel.size, group: 'framed', finish: f.value }); })
        : M.isAvailable(model, { size: sel.size, group: key, finish: null }));
    });
    all('[data-wa-finish]').forEach(function (b) {
      var f = b.getAttribute('data-wa-finish');
      press(b, sel.group === 'framed' && f === sel.finish);
      avail(b, M.isAvailable(model, { size: sel.size, group: 'framed', finish: f }));
    });
    model.groups.forEach(function (g) {
      var p = M.groupPrice(model, sel.size, g.key);
      setText('[data-wa-group-price="' + g.key + '"]', p ? (p.from ? 'from ' : '') + M.money(p.cents) : 'Not in this size');
    });
    model.finishes.forEach(function (f) {
      var c = M.finishPrice(model, sel.size, f.value);
      all('[data-wa-finish-price]').forEach(function (el) {
        if (el.getAttribute('data-wa-finish-price') === f.value) el.textContent = c == null ? '' : M.money(c);
      });
    });
    all('[data-wa-frame-panel], [data-wa-frame-panel-3d]').forEach(function (p) {
      p.setAttribute('data-open', sel.group === 'framed' ? 'true' : 'false');
    });
    var g = model.groups.filter(function (x) { return x.key === sel.group; })[0];
    var finishName = sel.finish ? sel.finish.replace(/^framed\s*-\s*/i, '') : '';
    var shown = sel.group === 'framed' ? 'Framed, ' + finishName : (g ? g.name : '');
    setText('[data-wa-size-label]', sel.size + ' in');
    setText('[data-wa-format-label]', g ? g.name : '');
    setText('[data-wa-finish-label]', sel.group === 'framed' && finishName && variant ? finishName + ' · ' + M.money(variant.price) : finishName);
    setText('[data-wa-variant-label]', sel.size + ' in · ' + shown);
    swapText('[data-wa-price]', variant ? M.money(variant.price) : '');
    var sale = !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
    all('[data-wa-compare]').forEach(function (el) { el.hidden = !sale; });
    setText('[data-wa-compare-price]', sale ? M.money(variant.compare_at_price) : '');
    // Every Add to cart (the buy box's and the 3D section's) shares one state. No Size or Format pickers in the buy box
    // (a product without the Size (inches) / Format options): nothing can be chosen, so they stay locked, as the section
    // renders them.
    var pickers = !!(root.querySelector('.wa-buy [data-wa-size]') && root.querySelector('.wa-buy [data-wa-group]'));
    all('[data-wa-add]').forEach(function (b) { b.disabled = !ok || adding || !pickers; });
    setText('[data-wa-add-price]', variant ? M.money(variant.price) : '');
    // Each error line says why its button is locked; a failed add's message (under the button clicked) clears here.
    setText('[data-wa-error]', ok ? '' : (variant ? 'Sold out in this size and format.' : 'Not available in this size. Choose another size or format.'));
    var box = root.querySelector('[data-wa-viz-box]'), pos = cfg.room && M.vizBox(sel.size, cfg.room);
    if (box) {
      box.hidden = !pos;
      if (pos) { box.style.left = pos.left; box.style.bottom = pos.bottom; box.style.width = pos.width; box.style.height = pos.height; }
    }
    var zoom = root.querySelector('[data-wa-viz-zoom]'), z = cfg.room && M.vizZoom(sel.size, cfg.room);
    if (zoom) {
      zoom.style.setProperty('--wa-viz-scale', z ? String(z.scale) : '1');
      zoom.style.transform = z ? 'scale(' + z.scale + ')' : '';
      zoom.style.transformOrigin = z ? z.originX + '% ' + z.originY + '%' : '';
    }
    // Style tiles: each sibling's variant with this Size and Format (M.styleHref), so a style switch keeps them.
    var styleFormat = variant ? variant.options[model.fi] : M.formatValue(model, sel);
    var view = new URLSearchParams(location.search).get('view');
    all('[data-wa-style]').forEach(function (a) {
      var sib = styles[parseInt(a.getAttribute('data-wa-style'), 10)];
      if (!sib) return;
      var href = M.styleHref(sib, sel.size, styleFormat, { view: view, path: location.pathname, hash: a.getAttribute('data-wa-style-hash') || '' });
      if (a.getAttribute('href') !== href) a.setAttribute('href', href);
    });
    all('[data-wa-viz-label]').forEach(function (el) { el.hidden = !pos; });
    setText('[data-wa-viz-label]', sel.size + ' in');
    followVizLabel();
    if (variant && String(new URLSearchParams(location.search).get('variant')) !== String(variant.id)) {
      var u = new URL(location.href); u.searchParams.set('variant', variant.id);
      // The GG slider (gg-product-page-slider.js) wraps history.replaceState to fire its locationchange, and its handler
      // throws (TypeError, reading 'us') when that comes before its gallery has mounted: our first render, on DEV. The
      // first write only names the variant the server already rendered, so it goes through the native method and GG is
      // not told. A shopper's change goes through the wrapper, so GG follows it; if that throws, the native method still
      // writes ?variant= and the change events below still fire.
      var native = function () { try { History.prototype.replaceState.call(history, history.state, '', u.toString()); } catch (e2) { /* no history API */ } };
      if (!rendered) native();
      else { try { history.replaceState(history.state, '', u.toString()); } catch (e) { native(); } }
    }
    rendered = true;
    root.dispatchEvent(new Event('change', { bubbles: true }));
    root.dispatchEvent(new CustomEvent('wa:change', { detail: { sel: sel, variant: variant } }));
    syncBundle();
  }

  // Size guide: the label sits outside the zooming room (so it stays crisp) and follows the outline on screen, every
  // frame while the zoom runs (500ms). Its side is chosen from where the zoom ends: above the outline, --wa-viz-gap away
  // (the same custom property the section's first paint uses), when that leaves it 6px inside the photo; otherwise just
  // inside the outline's top edge when it fits there; otherwise just below the outline (a phone's largest sizes, whose
  // outline comes within the label's height of the photo's top and is narrower than the label). Placed in % so it holds
  // when the photo resizes.
  var vizEl = root.querySelector('[data-wa-viz]'), followUntil = 0, following = false, vizSide = 'above', EDGE = 6;
  function vizParts() {
    var label = vizEl && vizEl.querySelector('[data-wa-viz-label]'), box = vizEl && vizEl.querySelector('[data-wa-viz-box]');
    return label && box && !box.hidden ? { label: label, box: box, gap: parseFloat(getComputedStyle(vizEl).getPropertyValue('--wa-viz-gap')) || 0 } : null;
  }
  function chooseVizSide() {
    var p = vizParts(), pos = cfg.room && M.vizBox(sel.size, cfg.room), z = cfg.room && M.vizZoom(sel.size, cfg.room);
    var v = vizEl && vizEl.getBoundingClientRect();
    if (!p || !pos || !z || !v.height) return 'above';
    var h = parseFloat(pos.height), cy = 100 - parseFloat(pos.bottom) - h / 2;          // % from the top; the zoom's fixed point
    var top = (cy - h * z.scale / 2) / 100 * v.height, bottom = (cy + h * z.scale / 2) / 100 * v.height;
    var width = parseFloat(pos.width) * z.scale / 100 * v.width, lw = p.label.offsetWidth, lh = p.label.offsetHeight;
    if (top - p.gap - lh >= EDGE) return 'above';
    if (lw + 2 * p.gap <= width && lh + 2 * p.gap <= bottom - top) return 'inside';
    if (bottom + p.gap + lh <= v.height - EDGE) return 'below';
    return 'above';
  }
  function placeVizLabel() {
    var p = vizParts();
    if (!p) return;
    var v = vizEl.getBoundingClientRect(), b = p.box.getBoundingClientRect(), lh = p.label.offsetHeight;
    if (!v.width || !v.height) return;
    var top = vizSide === 'inside' ? b.top - v.top + p.gap : vizSide === 'below' ? b.bottom - v.top + p.gap : Math.max(EDGE, b.top - v.top - p.gap - lh);
    p.label.style.left = ((b.left + b.width / 2 - v.left) / v.width * 100).toFixed(3) + '%';
    p.label.style.bottom = ((v.height - top - lh) / v.height * 100).toFixed(3) + '%';
    p.label.setAttribute('data-wa-viz-side', vizSide);
  }
  function followVizLabel() {
    if (!vizEl) return;
    vizSide = chooseVizSide();
    placeVizLabel();
    followUntil = Date.now() + 560;
    if (following) return;
    following = true;
    var tick = function () {
      placeVizLabel();
      if (Date.now() < followUntil) requestAnimationFrame(tick); else following = false;
    };
    requestAnimationFrame(tick);
    setTimeout(placeVizLabel, 600);                       // in case animation frames are paused (a background tab)
  }
  window.addEventListener('resize', function () { if (vizEl) { vizSide = chooseVizSide(); placeVizLabel(); } });
  // The photo's box also changes without a window resize: the size guide's styles are in wall-art-pdp-below.css, which
  // loads without blocking render and can arrive after the first render has placed the label on the unstyled layout.
  if (vizEl && 'ResizeObserver' in window) new ResizeObserver(function () { vizSide = chooseVizSide(); placeVizLabel(); }).observe(vizEl);

  // Bundle and save: the widget's "this item" row is this product's variant select (its options carry
  // {"isForProduct": true, "id": ...} as their value). It starts on the first variant; keep it on the shopper's
  // selection, the same way Pediment's Ownership script sets the book's row (set the value, then click and change).
  function syncBundle() {
    var v = M.variantFor(model, sel), mountEl = root.querySelector('.Logbase-bought_together');
    if (!v || !mountEl) return;
    Array.prototype.forEach.call(mountEl.querySelectorAll('select.lb-shared-variants-select, select.lb-upsell-variants-select'), function (select) {
      var match = null, ours = false;
      Array.prototype.forEach.call(select.options, function (opt) {
        var d = null;
        try { d = JSON.parse(opt.value); } catch (e) { d = null; }
        if (!d || typeof d !== 'object') { if (String(opt.value) === String(v.id)) match = opt; return; }
        if (d.isForProduct === true) ours = true;
        if (String(d.id) === String(v.id)) match = opt;
      });
      if (!ours || !match || select.value === match.value) return;
      select.value = match.value;
      match.dispatchEvent(new Event('click'));
      select.dispatchEvent(new Event('change'));
    });
  }

  function framedAt(size, finish) { return M.isAvailable(model, { size: size, group: 'framed', finish: finish }); }

  function select(partial) {
    var p = {}, k;
    for (k in partial) if (Object.prototype.hasOwnProperty.call(partial, k)) p[k] = partial[k];
    var explicit = !!p.finish;
    if (p.group && p.group !== 'framed') p.finish = null;
    var next = { size: p.size || sel.size, group: p.group || sel.group, finish: 'finish' in p ? p.finish : sel.finish };
    if (next.group === 'framed') {
      // Framed comes back with the last frame chosen; if that frame is not made at this size, take the first one that is.
      if (!explicit) next.finish = lastFinish || next.finish;
      if (!explicit && !framedAt(next.size, next.finish)) {
        var alt = model.finishes.filter(function (f) { return framedAt(next.size, f.value); })[0];
        if (alt) next.finish = alt.value;
      }
      if (explicit) lastFinish = next.finish;
    }
    sel = next;
    render();
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b) || b.getAttribute('aria-disabled') === 'true') return;
    if (b.hasAttribute('data-wa-size')) select({ size: b.getAttribute('data-wa-size') });
    else if (b.hasAttribute('data-wa-group')) select({ group: b.getAttribute('data-wa-group') });
    else if (b.hasAttribute('data-wa-finish')) select({ group: 'framed', finish: b.getAttribute('data-wa-finish') });
    else if (b.hasAttribute('data-wa-add')) addToCart(b);
  });

  // The error line that belongs to a button: the nearest one in its own block (.wa-buy__cta).
  function errorFor(btn) {
    for (var el = btn.parentElement; el && el !== root.parentElement; el = el.parentElement) {
      var e = el.querySelector('[data-wa-error]');
      if (e) return e;
    }
    return null;
  }

  function addToCart(btn) {
    var v = M.variantFor(model, sel);
    if (adding || !v || !v.available) return;
    adding = true;                                        // every Add to cart locks until this one settles
    all('[data-wa-add]').forEach(function (b) { b.disabled = true; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); api.go('/cart'); })
      .catch(function () {
        adding = false; render();
        var err = errorFor(btn);
        if (err) err.textContent = 'That did not go through. Please try again.';
      });
  }

  // Back from /cart can restore this page from the back/forward cache with every Add to cart still locked.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { adding = false; render(); } });

  // Judge.me's count arrives as raw digits.
  all('[data-wa-review-count]').forEach(function (el) {
    el.textContent = el.textContent.replace(/^(\d{4,})/, function (n) { return parseInt(n, 10).toLocaleString('en-US'); });
  });

  // Sections fade up as they enter (CSS turns this off under reduced motion).
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    all('[data-wa-reveal]').forEach(function (el) { io.observe(el); });
  } else all('[data-wa-reveal]').forEach(function (el) { el.classList.add('is-in'); });

  // 3D: the AR button shows only where model-viewer can open AR (it decides a moment after load).
  var mv = root.querySelector('model-viewer[data-wa-model]'), arBtn = root.querySelector('[data-wa-ar]');
  if (mv && arBtn) {
    var arWrap = root.querySelector('[data-wa-ar-wrap]') || arBtn;   // the button and its note show and hide together
    var check = function () { arWrap.hidden = !mv.canActivateAR; };
    mv.addEventListener('load', function () { check(); setTimeout(check, 1200); });
    arBtn.addEventListener('click', function () { if (mv.activateAR) mv.activateAR(); });
  }
  // 3D: aim the camera at the middle of what the model shows. A 3d-gen wall-art GLB carries every Format at once (the
  // ones not shown sit on a transparent material) with its origin at the piece's bottom edge, and model-viewer centres
  // on the box of every mesh: the tallest frame's. So a print, canvas, metal print or narrower frame sat low in the
  // stage (Thanks, JV, Metal, 13 x 24: 60px low at 1440). camera-target is set to the box of the visible meshes
  // (M.variantBounds) of model-viewer's own copy of the GLB's JSON (originalGltfJson), synchronously:
  //   - when model-viewer has the new model (its onModelLoad step, found by its symbol's name): model-viewer shows the
  //     model two frames before it fires `load`, and pd-3d-variants.js swaps in a per-size GLB on every size change, so
  //     aiming on `load` alone left two frames of the new model aimed at the old one's middle. The aim is for the Format
  //     pd-3d-variants.js is about to apply (the page's selection), so applying it moves nothing;
  //   - on `load` and on each `variant-applied` (a finish change), the same aim, which changes nothing when it holds.
  // It jumps there until the shopper has moved the camera (pd-3d-camera's data-pd-touched), then glides. pd-3d-camera.js
  // keeps the orbit, distance and field of view. Where model-viewer has no originalGltfJson (another version), the JSON
  // chunk is read from the GLB itself (the HTTP cache: model-viewer has just fetched it) on `load` instead.
  // The same for the 3D section's viewer and the gallery's inline one (Task 23: aim(mv, true), from galleryViewer).
  var gltfs = {};               // src -> Promise of the GLB's JSON; a failed read is not kept, so it is tried again
  var parseGlb = function (buf) {
    var dv = new DataView(buf);
    if (buf.byteLength < 20 || dv.getUint32(0, true) !== 0x46546C67 || dv.getUint32(16, true) !== 0x4E4F534A) return null;
    var len = dv.getUint32(12, true);
    if (buf.byteLength < 20 + len || !window.TextDecoder) return null;
    return JSON.parse(new TextDecoder().decode(new Uint8Array(buf, 20, len)));
  };
  var readGltf = function (src) {
    if (!src || !window.fetch || !window.DataView || /^about:/i.test(src)) return Promise.resolve(null);
    if (gltfs[src]) return gltfs[src];
    var read = fetch(src, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) return null;
      if (!r.body || !r.body.getReader) return r.arrayBuffer().then(parseGlb);
      var reader = r.body.getReader(), parts = [], got = 0, need = 20;
      var joined = function () {
        var out = new Uint8Array(got), at = 0;
        parts.forEach(function (p) { out.set(p, at); at += p.length; });
        return out.buffer;
      };
      var pump = function () {
        return reader.read().then(function (res) {
          if (res.value) { parts.push(res.value); got += res.value.length; }
          if (need === 20 && got >= 20) need = 20 + new DataView(joined()).getUint32(12, true);
          if (got >= need || res.done) {
            try { reader.cancel(); } catch (e) { /* already closed */ }
            return parseGlb(joined());
          }
          return pump();
        });
      };
      return pump();
    }).catch(function () { return null; }).then(function (json) {
      if (!json && gltfs[src] === read) delete gltfs[src];
      return json;
    });
    gltfs[src] = read;
    return read;
  };
  // The Format pd-3d-variants.js shows: the selected variant's first option whose slug (its rule: lower-case, no
  // "Framed -" or parenthetical, hyphens) is one of the model's variants, else the model's default (null).
  var slug = function (value) {
    return String(value).toLowerCase().replace(/\([^)]*\)/g, ' ').replace(/^\s*framed\s*[-:]?\s*/, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };
  // preview: the gallery's viewer. There a new size's GLB (pd-3d-variants.js swaps it in) keeps the shopper's framing:
  // the camera's distance scales by how much bigger the new model is against the box (the measure pd-3d-camera.js frames
  // by: the height, or the widest turn over the box's aspect), at the same onModelLoad step, and the angle the shopper
  // turned it to stays. Untouched, that is the distance pd-3d-camera.js then sets on `load`, so nothing moves twice;
  // turned, the new size still fits the slide, which has no zoom.
  function aim(mv, preview) {
    var shownVariant = function (gltf) {
      if (!mv.dataset.pdVariants) return mv.variantName || null;      // pd-3d-variants.js is not driving this viewer
      var names = (((gltf.extensions || {}).KHR_materials_variants || {}).variants || []).map(function (v) { return v.name; });
      var v = M.variantFor(model, sel), opts = (v && v.options) || [];
      for (var i = 0; i < opts.length; i++) if (names.indexOf(slug(opts[i])) !== -1) return slug(opts[i]);
      return null;
    };
    var aimAt = function (gltf, name) {
      var b = gltf && M.variantBounds(gltf, name);
      if (!b) return;
      var target = b.center.map(function (v) { return (Math.abs(v) < 5e-5 ? 0 : v).toFixed(4) + 'm'; }).join(' ');
      if (mv.getAttribute('camera-target') === target) return;
      if (preview) galleryTurnStop(mv);       // the intro turn (Task 24) stops before the camera is re-aimed
      mv.setAttribute('camera-target', target);
      if (!mv.dataset.pdTouched && mv.jumpCameraToGoal) mv.jumpCameraToGoal();
    };
    var aimNow = function (applied) {
      var gltf = mv.originalGltfJson;
      if (gltf) { aimAt(gltf, applied ? (mv.variantName || null) : shownVariant(gltf)); return; }
      var src = mv.getAttribute('src');
      readGltf(src).then(function (json) {
        if (json && mv.getAttribute('src') === src) aimAt(json, applied ? (mv.variantName || null) : shownVariant(json));
      });
    };
    var dims = null;              // the last model's size (metres), for the gallery's refit
    var refit = function () {
      if (!preview || !mv.getDimensions || !mv.getCameraOrbit) return;
      var d = mv.getDimensions(), r = mv.getBoundingClientRect();
      if (!d || !(d.x > 0 && d.y > 0) || r.width < 50 || r.height < 50) return;
      var was = dims; dims = { x: d.x, y: d.y, z: d.z };
      if (!was || (was.x === d.x && was.y === d.y && was.z === d.z)) return;
      var size = function (m) { return Math.max(m.y, Math.sqrt(m.x * m.x + m.z * m.z) / (r.width / r.height)); };
      galleryTurnStop(mv);
      var o = mv.getCameraOrbit(), deg = 180 / Math.PI;
      mv.setAttribute('camera-orbit', (o.theta * deg).toFixed(2) + 'deg ' + (o.phi * deg).toFixed(2) + 'deg ' + (o.radius * size(d) / size(was)).toFixed(3) + 'm');
      if (mv.jumpCameraToGoal) mv.jumpCameraToGoal();
    };
    var hooked = false;
    var hookModelLoad = function () {
      if (hooked) return;
      for (var p = Object.getPrototypeOf(mv); p && p !== HTMLElement.prototype; p = Object.getPrototypeOf(p)) {
        var syms = Object.getOwnPropertySymbols(p);
        for (var i = 0; i < syms.length; i++) {
          if (String(syms[i]) !== 'Symbol(onModelLoad)' || typeof p[syms[i]] !== 'function') continue;
          var key = syms[i], step = mv[key];
          mv[key] = function () {
            var out = step.apply(this, arguments);
            try { aimNow(false); refit(); } catch (e) { /* the load listener aims instead */ }
            return out;
          };
          hooked = true;
          return;
        }
      }
    };
    mv.addEventListener('load', function () { aimNow(false); refit(); });
    mv.addEventListener('variant-applied', function () { aimNow(true); });
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('model-viewer').then(function () { hookModelLoad(); if (mv.loaded) { aimNow(false); refit(); } });
    }
    if (mv.loaded) { aimNow(false); refit(); }
  }
  if (mv) aim(mv, false);

  // The gallery's viewer starts on the chosen size (Task 23). pd-3d-variants.js keeps an `ar` viewer on the chosen
  // size's GLB from the AR manifest (/cdn/shop/files/pd-ar-<product id>.json, sizes keyed by the Size value), but it
  // reads the manifest only once a viewer has loaded a model, so the slide would first show the product's Shopify model
  // and then swap. Until the gallery's viewer first loads (model-viewer loads it when the slide is shown), its src is
  // set here to the selected size's GLB from the same manifest (the same URL, so the browser's cache serves
  // pd-3d-variants' own read), with pd-3d-variants' markers (data-pd-orig-src, data-pd-ar-src), so from its first load
  // on it is pd-3d-variants' viewer like the others. A product without a manifest keeps pmslider's src.
  var arManifest = null, arRead = null;     // the read, and the manifest once it is here
  function manifest() {
    if (!arManifest) {
      arManifest = product.id && window.fetch
        ? fetch('/cdn/shop/files/pd-ar-' + product.id + '.json?v=' + Math.floor(Date.now() / 3600000), { credentials: 'omit' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (m) { return (arRead = m && m.sizes ? m : null); })
          .catch(function () { return null; })
        : Promise.resolve(null);
    }
    return arManifest;
  }
  function sizeEntry(m) {
    var v = M.variantFor(model, sel), opts = (v && v.options) || [sel.size], entry = null;
    for (var i = 0; i < opts.length && !entry; i++) entry = m.sizes[opts[i]] || null;
    return entry;
  }
  function startSize(gmv) {
    if (gmv.loaded || gmv.hasAttribute('data-wa-loaded')) return;
    manifest().then(function (m) {
      if (!m || gmv.loaded || gmv.hasAttribute('data-wa-loaded')) return;
      var entry = sizeEntry(m), src = gmv.getAttribute('src'), ours = gmv.dataset.pdArSrc;
      if (entry && entry.glb) {
        if (src === entry.glb) return;
        if (!ours) gmv.dataset.pdOrigSrc = src || '';
        gmv.dataset.pdArSrc = entry.glb;
        gmv.setAttribute('src', entry.glb);
      } else if (ours && src === ours && gmv.dataset.pdOrigSrc) {   // a size the manifest lacks: pmslider's model
        gmv.setAttribute('src', gmv.dataset.pdOrigSrc);
        delete gmv.dataset.pdArSrc; delete gmv.dataset.pdOrigSrc;
      }
    });
  }
  // data-wa-sized (for the intro turn, Task 24): the viewer has loaded the model it is now showing, and that is the
  // selected size's GLB (or the manifest has none for it). When pd-3d-variants keeps pmslider's model instead (a Format
  // with no AR file at that size), the model counts as settled once its src has not changed for 1.5 s. Kept per viewer
  // element (the src it last loaded, that 1.5 s timer), so a viewer pmslider recreates starts fresh.
  var sizing = new WeakMap();
  function sized(gmv) {
    var st = sizing.get(gmv);
    if (!st) sizing.set(gmv, st = { loadedSrc: null, settle: 0 });
    return st;
  }
  function markSized(gmv) {
    var st = sized(gmv);
    manifest().then(function (m) {
      var src = gmv.getAttribute('src'), entry = m && sizeEntry(m);
      clearTimeout(st.settle);
      if (!gmv.hasAttribute('data-wa-loaded') || st.loadedSrc !== src) { gmv.removeAttribute('data-wa-sized'); return; }
      if (!entry || !entry.glb || src === entry.glb) { gmv.setAttribute('data-wa-sized', ''); return; }
      gmv.removeAttribute('data-wa-sized');
      st.settle = setTimeout(function () { if (gmv.getAttribute('src') === st.loadedSrc) gmv.setAttribute('data-wa-sized', ''); }, 1500);
    });
  }
  function loaded(gmv) { gmv.setAttribute('data-wa-loaded', ''); sized(gmv).loadedSrc = gmv.getAttribute('src'); markSized(gmv); }
  // pmslider puts its own model back each time the 3D slide becomes current (src '' and then the product's Shopify GLB,
  // in one go). On a viewer the AR-size path drives (data-pd-ar-src, set by startSize or pd-3d-variants.js), that is put
  // straight back to the selected size's GLB here. This runs in the gallery's MutationObserver, before model-viewer's
  // own update, which then finds its src unchanged and loads nothing: the Shopify model never shows. A src that is not
  // the one last loaded un-marks the viewer at once (data-wa-sized, so the intro waits for the right model; the aim
  // runs on that model's load), and so does model-viewer having started a load anyway.
  gallerySrc = function (gmv) {
    var ours = gmv.dataset.pdArSrc, src = gmv.getAttribute('src') || '';
    if (ours && src !== ours && (src === '' || src === gmv.dataset.pdOrigSrc)) {
      var entry = arRead && sizeEntry(arRead), want = (entry && entry.glb) || ours;
      if (want !== ours) gmv.dataset.pdArSrc = want;
      gmv.setAttribute('src', want);
      src = want;
      Promise.resolve(gmv.updateComplete).then(function () { if (gmv.loaded === false) gmv.removeAttribute('data-wa-sized'); });
    }
    if (src !== sized(gmv).loadedSrc && gmv.hasAttribute('data-wa-sized')) gmv.removeAttribute('data-wa-sized');
  };
  galleryViewer = function (gmv) {
    gmv.addEventListener('load', function () { loaded(gmv); });
    if (gmv.loaded) loaded(gmv);
    aim(gmv, true);
    startSize(gmv);
  };
  all('.wa-gallery model-viewer[data-wa-drag]').forEach(galleryViewer);
  root.addEventListener('wa:change', function () {
    all('.wa-gallery model-viewer[data-wa-drag]').forEach(function (g) { startSize(g); markSized(g); });
  });
  // Desktop: a QR code to this page (without ?variant=, so a phone opens the page fresh, then picks). Its library
  // (wa-qrcode.js, 56 KB; the URL is the section's data-wa-qr-src) is loaded only when the card comes within 400px of
  // the viewport and the pointer is fine: the card is .wa-only-fine, hidden under (hover: none) and (pointer: coarse),
  // and a hidden card never intersects, so a phone never fetches it. Already on the page (the review fixture loads
  // it), it just draws. Without IntersectionObserver it loads on the window's load, as it did before.
  var qr = root.querySelector('[data-wa-qr]');
  if (qr) {
    var qrDrawn = false, qrLoading = false;
    var draw = function () {
      if (qrDrawn || !window.qrcode) return false;
      var q = window.qrcode(0, 'M'); q.addData(location.origin + location.pathname); q.make();
      qr.innerHTML = q.createSvgTag({ cellSize: 3, scalable: true });   // default 4-module quiet zone, so it scans on the card
      qrDrawn = true;
      return true;
    };
    var coarse = window.matchMedia ? window.matchMedia('(hover: none) and (pointer: coarse)') : null;
    var qrLoad = function () {
      if (draw() || qrLoading || (coarse && coarse.matches)) return;
      var src = qr.getAttribute('data-wa-qr-src');
      if (!src) return;
      qrLoading = true;
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = draw;
      s.onerror = function () { qrLoading = false; };     // a later approach tries again
      document.head.appendChild(s);
    };
    if ('IntersectionObserver' in window) {
      var qrIo = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) qrLoad(); });
        if (qrDrawn) qrIo.disconnect();
      }, { rootMargin: '400px 0px' });
      qrIo.observe(qr.closest('.wa-qr-card') || qr);
    } else if (document.readyState === 'complete') qrLoad();
    else window.addEventListener('load', qrLoad);
  }

  // In-page links: a quick smooth scroll (350 ms, ease-out, one requestAnimationFrame per frame), then focus moves to the
  // target so keyboard and screen reader users land there too. Instant under reduced motion. The Judge.me and Selleasy
  // widgets keep their own links.
  var DURATION = 350, scrollRun = 0;
  function jumpTo(y) { try { window.scrollTo({ top: y, left: window.scrollX, behavior: 'instant' }); } catch (e) { window.scrollTo(window.scrollX, y); } }
  function targetTop(el) {
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var margin = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;   // CSS scroll-margin-top, as a native jump would
    return Math.max(0, Math.min(max, Math.round(el.getBoundingClientRect().top + window.scrollY - margin)));
  }
  function focusTarget(el) {
    if (!el.matches('a[href], button, input, select, textarea, summary, [tabindex]')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function scrollToTarget(el) {
    var run = ++scrollRun;
    if (reducedMotion()) { jumpTo(targetTop(el)); focusTarget(el); return; }
    var from = window.scrollY, start = null;
    function step(now) {
      if (run !== scrollRun) return;                      // a newer jump, or the shopper scrolled
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / DURATION), eased = 1 - Math.pow(1 - t, 3);
      jumpTo(from + (targetTop(el) - from) * eased);       // re-read the target: lazy images above it can move it
      if (t < 1) requestAnimationFrame(step); else focusTarget(el);
    }
    requestAnimationFrame(step);
  }
  ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
    window.addEventListener(type, function () { scrollRun++; }, { passive: true });
  });
  // A second click on the same link does not add another history entry.
  function setHash(id) {
    var hash = '#' + encodeURIComponent(id), u = location.pathname + location.search + hash;
    var method = location.hash === hash ? 'replaceState' : 'pushState';
    try { history[method](history.state, '', u); }
    catch (e) { try { History.prototype[method].call(history, history.state, '', u); } catch (e2) { /* no history API */ } }
  }
  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href^="#"]');
    if (!a || !root.contains(a) || a.closest('.jdgm-widget, .Logbase-bought_together')) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var el = id && (document.getElementById(id) || document.getElementsByName(id)[0]);
    if (!el) return;
    e.preventDefault();
    setHash(id);
    scrollToTarget(el);
  });

  // Bundle and save: the band and its button show once Selleasy's bought-together widget is up in the mount, so a
  // product with no bundle shows neither. The band stays laid out (collapsed, not display: none) so the widget can mount.
  // Two ways in: the widget's initialized event, or a real widget row (not just any element) appearing in the mount.
  var bundle = root.querySelector('[data-wa-bundle]'), bundleLink = root.querySelector('[data-wa-bundle-link]');
  var mount = bundle && bundle.querySelector('.Logbase-bought_together');
  var ROW = '.ppcse-card-product, .ppcse, .ppcse-m, .lb-upsell-money';
  function showBundle() {
    if (bundle) bundle.classList.add('is-ready');
    if (bundleLink) bundleLink.hidden = false;
    syncBundle();
  }
  window.addEventListener('lb-upsell-widget-event', function (e) {
    var d = e.detail || {};
    if (d.widgetType === 'product-page-cross-sell-embedded-widget' && d.status === 'initialized') showBundle();
  });
  if (mount) {
    if (mount.querySelector(ROW)) showBundle();
    else if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (mount.querySelector(ROW)) { showBundle(); mo.disconnect(); } });
      mo.observe(mount, { childList: true, subtree: true });
    }
  }

  api.select = select;
  api.state = function () { return { sel: sel, variant: M.variantFor(model, sel) }; };
  render();
})();
